import useCurrentUserId from "./useCurrentUserId";

export default function useIsLoggedIn() {
  const userId = useCurrentUserId();
  return userId !== null;
}
